module.exports = __webpack_public_path__ + "assets/img/fourth-user.e2275774.png";